export function convertMilesToKM(miles?: string | number): string {
  if (miles && Number(miles)) {
    const kilometers = Number(miles) * 1.60934;
    return kilometers?.toFixed(0);
  }
  return '0';
}
